import React, { useEffect, useState } from "react";
import logo from "../Images/Group 1171279193.png";
import phone from "../Images/Group.png";
import whatsapp from "../Images/whatsapp.png";
import menu from "../Images/Vector (16).png";
import { NavLink, useNavigate } from "react-router-dom";
import Sidebar2 from "./Sidebar2";
import { openWhatsAppLink } from "../Component/OpenWhatsApp";
const Header2 = () => {
  const [show, setShow] = useState(false);
  const sidebarfunc = () => {
    setShow(true);
  };
  const sidebarfunc2 = () => {
    setShow(false);
  };

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleAuthRedirect = () => {
    navigate("/profile");
  };
  return (
    <>
      <div className="header_2_main_wrapper">
        <div
          className="header_logo_main_div"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/");
          }}
        >
          <img src={logo} />
        </div>
        <div className="header_links_wrapper_div">
          <NavLink to={"/"} className="header_link">
            Home
          </NavLink>
          <NavLink className="header_link" to={"/propertylist"}>
            Properties
          </NavLink>
          <NavLink to={"/communitylist"} className="header_link">
            Community
          </NavLink>
          <NavLink className="header_link" to={"/profile"}>
            Profile
          </NavLink>
          <NavLink to={"/aboutus"} className="header_link">
            About Us
          </NavLink>
          <NavLink className="header_link" to={'/blog'}>Blog</NavLink>
          <NavLink className="header_link" to={"/pricingplan"}>
            Price
          </NavLink>
          <NavLink className="header_link" to={"/career"}>
            Careers
          </NavLink>
          {/* <NavLink className='header_link' to={'/career'}>Sign In</NavLink>
            <NavLink className='header_link' to={'/career'}>Sign Up</NavLink> */}
        </div>
        <div className="header_call_wrapper_div">
          <a href="tel:91987654321" style={{textDecoration:"none"}}>
            <div className="call_us_div5">
              <img src={phone} alt="Phone Icon" />
              <p>Call Us</p>
            </div>
          </a>

          <div className="chat_on_whatsapp_wrapper_div"
            style={{ cursor: "pointer" }}
            onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested")}
          >
            <img src={whatsapp} alt="WhatsApp Icon" />
            <p>Chat On Whatsapp</p>
          </div>

          {/* Conditional Rendering */}
          {isLoggedIn ? (
            <div onClick={sidebarfunc} className="menu_bar_wrapper_div">
              <img src={menu} alt="Menu Icon" />
            </div>
          ) : (
            <button className="auth_button" onClick={handleAuthRedirect}>
              Sign Up / Log In
            </button>
          )}
        </div>
      </div>
      {show && <Sidebar2 sidebarfunc2={sidebarfunc2} />}
    </>
  );
};

export default Header2;
